<div>
  <app-titlebar #titlebar [homeVisible]="true">
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="jk-grid-cols-4"> <!-- grid two column grid grid-cols-1 gap-6 xl:grid-cols-2 -->
      <div>
        <app-jkedit label="寄件人帳號" [(value)]="pageOpt.mailFrom" [required]="true"
          >
        </app-jkedit>
      </div>
      <div>
        <app-jkedit label="寄件人名稱" [(value)]="pageOpt.mailName" [required]="true"
          >
        </app-jkedit>
      </div>
      <div>
        <app-jkedit label="收件人帳號" [(value)]="pageOpt.mailTo" [required]="true"
          >
        </app-jkedit>
      </div>
    </div>

  </mat-tab>
  <mat-tab #myTabGrid label="報表明細">
    <mat-toolbar class="h-9">
    </mat-toolbar>
    <span class="text-2xl">表格點兩下打開報表</span>
    <button mat-flat-button (click)="doQuery()">重新顯示</button>
    <app-jkgridwin #jkgridwin id="jkgridwin" [width]="screenWidth" [defaultHeight]="500"  (rowClicked)="agRowClicked($event)"
      (doubleClick)="agRowDoubleClicked($event)" (afterGridReady)="afterGridReady($event)">
    </app-jkgridwin>
  </mat-tab>
  <mat-tab #myPdf label="PDF報表檢視">
    <mat-toolbar class="h-9">
      <!-- <button mat-flat-button color="primary" (click)="onDownloadReport()">下載報表</button> -->
      <button mat-flat-button (click)="doMail()">傳MAIL</button>
      <app-jkdownload #jkdownload [url]="reportSrv.urlPath" [fileName]="reportSrv.fileName">
      </app-jkdownload>
    </mat-toolbar>
    <app-jktext class="w-full" [label]="'網址:'" [value]="reportSrv.urlPath" [matTooltip]="reportSrv.urlPath"></app-jktext>
    <iframe [src]="reportSrv.urlPath | safe: 'resourceUrl' " type="application/pdf" width="100%" height="800px">
    </iframe>
  </mat-tab>
</mat-tab-group>

